import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import {
  getKeywordToolPage,
  KeywordToolSeoPage,
} from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const page = getKeywordToolPage('online-text-reader');
if (!page) throw new Error('Missing keyword SEO page: online-text-reader');

export const Route = createFileRoute('/_marketing/_seo/online-text-reader')({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title: page.metaTitle,
        description: page.metaDescription,
      }),
    ],
    links: [
      { rel: 'canonical', href: normalizeCanonicalUrl('/online-text-reader') },
    ],
  }),
  component: () => <KeywordToolSeoPage page={page} />,
});
